export default "__VITE_ASSET__CxjWEGjq__"